var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { logger } from '../utilites/logger';
import { NamespaceStore as StoreTypes } from '../models/ModelIDBStorageService';
export var getInitialSettingsState = function () {
  return {
    timer: true,
    sounds: true,
    darkMode: false,
    highlightErrors: false,
    arrowKeysToChangeDirection: false,
    skipOverFilledCells: true,
    jumpBackToBlanksAtTheEndOfWord: false,
    jumpToNextWordIfItIsFilled: true,
    highlightConflictingLetters: true,
    cluesPosition: StoreTypes.CluesPosition.RIGHT
  };
};
var DBStorage = /** @class */function () {
  function DBStorage() {
    this.storedObject = {
      settings: __assign({}, getInitialSettingsState()),
      lastPlayedPuzzleState: null,
      previouslyPlayedScores: {},
      previouslyPlayedPuzzles: {}
    };
    this._rawKey = '';
    this._postfix = 'default';
    this.DEFAULT_DB_VERSION = 1;
    this.db = null;
  }
  Object.defineProperty(DBStorage.prototype, "postfix", {
    /**
     * Sets postfix for key in storage
     *
     * @param postfix - skin name, "default" by default
     */
    set: function (postfix) {
      this._postfix = postfix;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DBStorage.prototype, "key", {
    /** Default key which storage uses */
    get: function () {
      return "".concat(this._rawKey, "___").concat(this._postfix, "___");
    },
    enumerable: false,
    configurable: true
  });
  DBStorage.prototype.connectDB = function () {
    return __awaiter(this, void 0, void 0, function () {
      var key;
      var _this = this;
      return __generator(this, function (_a) {
        key = this.key;
        return [2 /*return*/, new Promise(function (resolve) {
          try {
            var request = indexedDB.open(key, _this.DEFAULT_DB_VERSION);
            request.onerror = function () {
              logger.error("Why didn't you allow my web app to use IndexedDB?!");
            };
            request.onupgradeneeded = function (event) {
              logger.debug({
                onupgradeneeded: 'onupgrade'
              });
              var db = event.target.result;
              if (!db.objectStoreNames.contains(key)) {
                db.createObjectStore(key);
              }
            };
            request.onsuccess = function (event) {
              logger.debug('onsuccess');
              _this.db = event.target.result;
              logger.debug(_this.db);
              resolve();
            };
          } catch (e) {
            logger.error("can't open DB", e);
          }
        })];
      });
    });
  };
  /**
   * Get data from storage
   *
   * @param key - key of data you want to get
   *
   * @returns null if there is nothing for this key or data
   * */
  DBStorage.prototype.getItem = function (key) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;
      return __generator(this, function (_a) {
        if (!this.db) {
          return [2 /*return*/, null];
        }
        return [2 /*return*/, new Promise(function (resolve) {
          try {
            _this.db.transaction(_this.key, 'readwrite').objectStore(_this.key).get(key).onsuccess = function (event) {
              var _a;
              return resolve((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.result);
            };
          } catch (e) {
            logger.error(e);
          }
        })];
      });
    });
  };
  /**
   * Save data to storage
   *
   * @param key - key for item
   * @param item - data to be saved
   * */
  DBStorage.prototype.setItem = function (key, item) {
    return __awaiter(this, void 0, void 0, function () {
      var e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.db) {
              return [2 /*return*/];
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, this.db.transaction(this.key, 'readwrite').objectStore(this.key).put(item, key)];
          case 2:
            _a.sent();
            return [3 /*break*/, 4];
          case 3:
            e_1 = _a.sent();
            logger.error(e_1);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * Init store to connect with data from IndexedDB
   *
   * @param rawKey - game name
   * */
  DBStorage.prototype.init = function (rawKey) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;
      return __generator(this, function (_a) {
        if (!rawKey || rawKey.length === 0) throw Error('Key for storage is too short.');
        this._rawKey = rawKey;
        return [2 /*return*/, new Promise(function (resolve) {
          _this.connectDB().then(function (_) {
            return resolve();
          }).catch(function (e) {
            return logger.error(e);
          });
        })];
      });
    });
  };
  /**
   * Save score for the day
   *
   * @param puzzleUrl - url where puzzle was loaded, used as key for score in storage
   * @param totalScore - daily score, including all bonuses etc.
   * @param yearOfPlaying - to be able to clear old scores
   * */
  DBStorage.prototype.setScore = function (puzzleUrl, totalScore, yearOfPlaying) {
    var scoreKey = "".concat(puzzleUrl, "__").concat(yearOfPlaying, "__");
    /** we're saving only first attempt */
    if (scoreKey in this.storedObject.previouslyPlayedScores) return;
    this.storedObject.previouslyPlayedScores[scoreKey] = totalScore;
    this.saveToStorage();
  };
  Object.defineProperty(DBStorage.prototype, "settings", {
    /**
     * Get saved settings
     *
     * @returns object with all settings for redux store
     */
    get: function () {
      return this.storedObject.settings;
    },
    /**
     * Set settings to save in storage
     *
     * @param settings - object with all settings from redux store
     * */
    set: function (settings) {
      this.storedObject.settings = settings;
      this.saveToStorage();
    },
    enumerable: false,
    configurable: true
  });
  DBStorage.prototype.saveToStorage = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.setItem(this.key, this.storedObject)];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  return DBStorage;
}();
export var DBStorageInstance = new DBStorage();